// @react/hooks/usePaymentPaymentProvider.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { paymentPaymentProviderStore } from '@core/stores';

/**
 * React hook for PaymentProvider operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { usePaymentPaymentProvider } from '@react/hooks';
 *
 * const PaymentProviderList = observer(() => {
 *   const store = usePaymentPaymentProvider();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function usePaymentPaymentProvider() {
  return paymentPaymentProviderStore;
}
